import type { IconData } from '@stacksjs/iconify-core'

export const arrowTurnDownLargeSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.702 27.573c-1.373.1-2.424.811-2.91 1.842c-.484 1.03-.365 2.294.427 3.419c1.105 1.569 2.652 3.631 4.783 6.238c3.185 3.894 5.513 5.98 6.987 7.079c1.266.943 2.893.943 4.159 0c1.473-1.098 3.802-3.185 6.986-7.08c2.132-2.606 3.68-4.669 4.784-6.238c.793-1.125.912-2.39.427-3.419c-.485-1.03-1.536-1.741-2.91-1.84a114 114 0 0 0-4.584-.229a592 592 0 0 1-.102-5.778c-.057-4.358 2.775-7.98 6.985-7.98c4.461 0 7.549 3.883 7.549 8.489v12.208c0 1.81.97 3.639 2.936 3.974c.73.124 1.617.21 2.673.21s1.943-.086 2.673-.21c1.967-.335 2.936-2.163 2.936-3.974V20.6C47.501 9.868 39.543.73 28.734.73c-11.636 0-20.311 9.869-20.46 21.426c-.023 1.761-.05 3.512-.082 5.191a114 114 0 0 0-4.49.225\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowTurnDownLargeSolid
